// @flow

import 'core-js/fn/regexp/escape';

/**
 * Retreive cookie.
 */
export function getCookie(key: string): ?string {
  // $FlowFixMe Non-standard RegExp method
  const regex = new RegExp(`(?:^|;)(?:\\s*)${RegExp.escape(key)}=([^;]+)`);
  const match = document.cookie.match(regex);

  if (match && match[1]) {
    return decodeURIComponent(match[1]);
  }

  return null;
}

/**
 * Set a session cookie on the root path.
 */
export function setCookie(key: string, value: string): void {
  document.cookie = `${key}=${encodeURIComponent(value)}; path=/`;
}

export function doNotSell(): boolean {
  const cookieBoolean = getCookie('do_not_sell');
  if (cookieBoolean) {
    return JSON.parse(cookieBoolean);
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/lib/utils.js